import createHttp from '@/config/http';
import type { SupportTicketRaw, SupportTicketDetailsResponse } from '@/types/supportTicket';
import type { ResponseMetaData } from '@/types/service';

const http = createHttp(
  import.meta.env.VITE_CASES_URL || 'http://localhost:3007',
);

export const getSupportTickets = async (
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	status = '',
	globalFilters = '[]',
	sort = '',
): Promise<{
	items: SupportTicketRaw[];
	meta: ResponseMetaData;
}> => {
  const params = {
    page: String(page),
    limit: String(limit),
    columnsFilters,
    search,
    status: String(status),
    globalFilters,
    sort,
  };

  const response = await http.get('/support-tickets', { params });

	return {
    items: response.data.data.items || [],
    meta: response.data.data.metaData || {},
	};
};

export const getSupportTicket = async (id: string): Promise<SupportTicketDetailsResponse> => {
  const response = await http.get(`/support-tickets/${id}`);
  return response.data.data;
};

export interface CreateSupportTicketPayload {
  new_patientfirstname?: string;
  new_patientlastname?: string;
  emailaddress?: string;
  createdon: string;
  description?: string;
  title: string;
  prioritycode: number;
  statuscode: number;
  casetypecode: number;
  ta_origin: number; // Static: 953870004
  'customerid_account@odata.bind': string; // Format: "contacts(guid)"
  ta_documentupload?: string;
  ta_department: number; // Static: 953870011
}

export interface UpdateSupportTicketPayload {
  title?: string;
  description?: string;
  prioritycode?: number;
  statuscode?: number;
  casetypecode?: number;
  ta_documentupload?: string;
}

export const createSupportTicket = async (
  ticketData: CreateSupportTicketPayload,
): Promise<any> => {
  const response = await http.post('/support-tickets', ticketData);
  return response.data.data;
};

export const updateSupportTicket = async (
  id: string,
  ticketData: UpdateSupportTicketPayload,
): Promise<any> => {
  const response = await http.patch(`/support-tickets/${id}`, ticketData);
  return response.data.data;
};




